module.exports = __webpack_public_path__ + "static/media/catania,Italy.579dec67.png";